"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeInput = DateRangeInput;

var React = _interopRequireWildcard(require("react"));

var _datetime = require("@blueprintjs/datetime");

var _index = require("../../index");

var _dateFns = require("date-fns");

var _dateUtils = require("../../common/dateUtils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * There's a lot of duplication between this and the DateInput.
 * Should look to refactor this at some point.
 */


function DateRangeInput(_ref) {
  var clearable = _ref.clearable,
      fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ["clearable", "fill"]);

  var value = props.value || [null, null];
  var turbolinksFixPortalDocumentBody = document.body;

  var popoverProps = _objectSpread(_objectSpread({}, props.popoverProps), {}, {
    fill: fill,
    modifiers: {
      arrow: {
        enabled: false
      },
      offset: {
        offset: '0, 8'
      }
    },
    portalContainer: turbolinksFixPortalDocumentBody,
    position: _index.Position.BOTTOM
  });
  /**
   * By default we're going to constrain the inputs to be as small as possible by using a lovely fixed width
   */


  var defaultProps = {
    dayPickerProps: {
      weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },
    endInputProps: {
      fill: fill,
      leftElement: /*#__PURE__*/React.createElement(_index.Icon16, {
        icon: _index.IconNames16.CALENDAR,
        fill: _index.Colors.GREY_30
      }),
      rightElement: clearable && value[1] ? /*#__PURE__*/React.createElement(_index.IconButton24, {
        icon: _index.IconNames8.CROSS,
        onClick: clearEnd
      }) : undefined,
      style: fill ? {} : {
        width: '185px'
      }
    },
    startInputProps: {
      fill: fill,
      leftElement: /*#__PURE__*/React.createElement(_index.Icon16, {
        icon: _index.IconNames16.CALENDAR,
        fill: _index.Colors.GREY_30
      }),
      rightElement: clearable && value[0] ? /*#__PURE__*/React.createElement(_index.IconButton24, {
        icon: _index.IconNames8.CROSS,
        onClick: clearStart
      }) : undefined,
      style: fill ? {} : {
        width: '185px'
      }
    }
  };

  function clearStart() {
    if (props.onChange) {
      props.onChange([null, value[1]]);
    }
  }

  function clearEnd() {
    if (props.onChange) {
      props.onChange([value[0], null]);
    }
  }
  /**
   * The native implementation of Date functions differs between browsers.
   * Unsurprisingly IE11 struggles, so we'll ensure consistency by using date-fns.
   */


  var dateFnsFormatter = {
    formatDate: function formatDate(date) {
      return (0, _dateFns.formatISO)(date, {
        representation: 'date'
      });
    },

    /**
     * This function differs between the DateInput and DateRangeInput.
     * For DateInput Blueprint will throw an error if the date you enter manually does not fall
     * within the min and max date specified.
     * For this one, it will correctly display the out of range message.
     */
    parseDate: function parseDate(userInputString) {
      var date = (0, _dateFns.parseISO)(userInputString);
      if (!(0, _dateFns.isValid)(date)) return false;
      return date;
    },
    placeholder: 'YYYY-MM-DD'
  };
  return /*#__PURE__*/React.createElement(_datetime.DateRangeInput, _extends({}, defaultProps, dateFnsFormatter, props, {
    popoverProps: popoverProps,
    minDate: props.minDate || (0, _dateUtils.getDefaultMinDate)(),
    maxDate: props.maxDate || (0, _dateUtils.getDefaultMaxDate)()
  }));
}